export class UnrecognizedTagError extends Error {
    /*istanbul ignore next*/
    constructor(tag) {
        super(`Given tag is not recognized: ${tag}`);
    }
}
//# sourceMappingURL=unrecognized-tag.error.js.map